









import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component
export default class HelloClass extends Vue {

  @Prop() private msg!: string;

  @Watch('counter') onCounterChange(val: number, oldVal: number){
    if(val > 10) alert('Łał juz 10!');
    if(oldVal === 10 && val < 10) alert('Wracamy do 0 :) ?');
  }

  counter: number = 0;

  mounted() {
    console.log(this);
    console.log(this.$store);
    console.log(this.msg);
  }

  changeValue(value: number): void {
    this.counter += value;
  }

  get label(): any {
    console.log(this);
    return {}
  }

}
